import { MONTH_LIST } from '../utils/shortcuts'
import '../style/shortcuts-month.scss'

export default {
  functional: true,
  render(h, context) {
    const disabledMonth = typeof context.props.disabledMonth === 'function' ? context.props.disabledMonth : () => false
    const inner = () => {
      return MONTH_LIST.map((ele, index) => {
        const btnAttrs = {
          props: {
            type: 'text',
            disabled: disabledMonth(ele, index)
          },
          class: {
            'kye-shortcut-month-btn': true
          },
          on: {
            click: () => {
              context.props.handleShortcutMonthClick(index, ele)
            }
          }
        }
        return (<kye-button {...btnAttrs}>
          <div class='shortcut-text'>{ele}</div>
        </kye-button>)
      })
    }
    return <div class='kye-shortcut-month'>
      <div class='back' on-click={() => context.props.changeShortcutMonth(false)}>
        <i class='el-icon-arrow-left'></i>
        <span>返回</span>
      </div>
      <div class='wrap'>
        {
          inner()
        }
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/basic/shortcut-month.js